module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/dashboard/EmployeeRow.ejs -->\n<tr>\n    <td>'+
((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
'</td>\n    <td class="text-right">\n        ';
 if (!employee.has('invitedAt')) { 
__p+='\n            <span class="label label-success">Uninvited</span>\n        ';
 } else if (!employee.get('userId')) { 
__p+='\n            Has never logged in\n        ';
 } 
__p+='\n    </td>\n    <td class="text-right">\n        ';
 if (!employee.has('invitedAt') && employee.get('email')) { 
__p+='\n            <a class="js-invite">Invite</a>\n        ';
 } else if (employee.get('email')) { 
__p+='\n            <a class="js-invite">Invite again</a>\n        ';
 } else { 
__p+='\n            <a href="'+
((__t=( '#employee/' + employee.id ))==null?'':_.escape(__t))+
'">\n                Add email to invite\n            </a>\n        ';
 } 
__p+='\n        <a class="m-l-md" href="'+
((__t=( '#employee/' + employee.id ))==null?'':_.escape(__t))+
'">\n            Edit profile\n        </a>\n    </td>\n</tr>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/dashboard/EmployeeRow.ejs
// module id = 1020
// module chunks = 1